export enum AdminBackgroundTaskType {
  OrderComplete = 'ORDER_COMPLETE',
  SimulateOrderComplete = 'SIMULATE_ORDER_COMPLETE',
  OrderLabelsPackageGenerate = 'ORDER_LABELS_PACKAGE_GENERATE',
  SubscriptionProcess = 'SUBSCRIPTION_PROCESS',
  SubscriptionPriceChanging = 'SUBSCRIPTION_PRICE_CHANGING',
}
